import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { TituloResponseDTO } from '../../models/dashboard/titulo.model';

export interface TipoDeCobrancaDTO {
  tituloId: number;
  valor: number;
}

export interface MovimentoBaixaTituloDTO {
  tipoDeTransacao: 'RECEITA' | 'DESPESA';
  tipoReceita?: string;
  tipoDespesa?: string;
  valor: number;
  cotacaoId: number;
  contaId?: number | null;
  pessoaId?: number | null;
  moedaDeOrigem: string;
  cancelado: boolean;
  emissao: string;
  baixas: any[];
  tipoDeCobranca: TipoDeCobrancaDTO[];
  valorRecebidoNaConta: number;
  valorRecebidoEmGuarani: number;
  valorRecebidoEmDolar: number;
  valorRecebidoEmReal: number;
  /** Opcional: valor recebido em Peso Argentino (dinheiro). */
  valorRecebidoEmPeso?: number;
}

@Injectable({ providedIn: 'root' })
export class TituloService {

  constructor(private apiService: ApiService) {}

  buscarTitulosPorPessoa(params: {
    page: number;
    /** Tamanho da pagina. Ausente = 15 (fallback historico, preserva callers antigos). */
    size?: number;
    tipoOperacaoFinanceira: 'ENTRADA' | 'SAIDA';
    situacao?: 'ABERTO' | 'PAGO';
    pessoaId: number;
    dataHoraInicial?: string;
    dataHoraFinal?: string;
    conta?: number;
    /** Ordenacao server-side no formato Spring "campo,direcao" (ex.: "vencimento,desc"). */
    sort?: string;
  }): Observable<TituloResponseDTO> {
    const parts: string[] = [
      `page=${params.page}`,
      `size=${params.size ?? 15}`,
      `tipoOperacaoFinanceira=${params.tipoOperacaoFinanceira}`,
      `pessoaId=${params.pessoaId}`,
    ];
    // Ordenacao server-side: so envia quando o usuario escolheu uma coluna.
    // Sem isso, o backend aplica sua ordenacao padrao.
    if (params.sort) parts.push(`sort=${params.sort}`);
    if (params.dataHoraInicial) parts.push(`dataHoraInicial=${params.dataHoraInicial}`);
    if (params.dataHoraFinal) parts.push(`dataHoraFinal=${params.dataHoraFinal}`);
    if (params.situacao) parts.push(`situacao=${params.situacao}`);
    if (params.conta) parts.push(`conta=${params.conta}`);

    const query = parts.join('&');
    return this.apiService.read<TituloResponseDTO>(
      `/titulos/buscarPorOperacaoFinanceiraESituacaoAberto?${query}`
    );
  }

  /**
   * Dá baixa em um título aberto criando um movimento financeiro via POST /movimento.
   * O backend não possui PUT /titulos — a baixa é registrada como um movimento
   * de receita (ENTRADA) ou despesa (SAIDA) com o tipoDeCobranca vinculando o título.
   */
  gerenciarTituloAberto(body: MovimentoBaixaTituloDTO): Observable<any> {
    return this.apiService.create<any>('/movimento', body);
  }
}
